var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('TopBar'),_c('img',{staticClass:"certificate",attrs:{"src":_vm.cerUrl}}),_c('div',{staticClass:"button-primary button",on:{"click":_vm.download}},[_c('span',[_vm._v("下载达人卡")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }